import Component from "./functional";
export default Component;
